import {
    /** FETCH APPLICATION  */
    FETCH_GETAPPLICATIONS_FULFILLED,
    FETCH_GETAPPLICATIONS_REJECTED,
    FETCH_GETAPPLICATIONS_PENDING,
} from "../../actions/application/getApplications";
const initialState = {
    done: false,
    error: {},
    spinner: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_GETAPPLICATIONS_PENDING:
            return {
                done: false,
                error: {},
                spinner: true,
            };
        case FETCH_GETAPPLICATIONS_FULFILLED:
            return {
                ...state,
                getApplications: action.payload,
                done: true,
                spinner: false,
            };
        case FETCH_GETAPPLICATIONS_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false,
            };
        default:
            return state;
    }
};